/* eslint-disable max-classes-per-file */
import { createAction, props } from '@ngrx/store';
import { ValidateIdentity } from './validate.model';
import { TwoFACode } from '@app/auth/core/state/auth.model';

export const ActionTypes = {
  VALIDATE: '[Auth] Validate',
  VALIDATE_SUCCESS: '[Auth] Validate Success',
  VALIDATE_FAILURE: '[Auth] Validate Failure',
  VALIDATE_LINK: '[Auth] Validate Link',
  VALIDATE_LINK_SUCCESS: '[Auth] Validate Link Success',
  VALIDATE_LINK_FAILURE: '[Auth] Validate Link Failure',
  VERIFY_2FA_CODE: '[Auth] Verify 2FA Code',
  VERIFY_2FA_CODE_FAILURE: '[Auth] Verify 2FA Code Failure',
};

export const validate = createAction(
  ActionTypes.VALIDATE,
  props<{ payload: ValidateIdentity }>()
);

export const validateSuccess = createAction(
  ActionTypes.VALIDATE_SUCCESS
);

export const validateFailure = createAction(
  ActionTypes.VALIDATE_FAILURE,
  props<{ payload: { code?: string; message: string; httpStatus?: number } }>()
);

export const validateEmailVerify2FACode = createAction(
  ActionTypes.VERIFY_2FA_CODE,
  props<{ payload: TwoFACode }>()
);

export const validateEmailVerify2FACodeFailure = createAction(
  ActionTypes.VERIFY_2FA_CODE_FAILURE,
  props<{ payload: { code: string } }>()
);

export const validateLink = createAction(
  ActionTypes.VALIDATE_LINK,
  props<{ payload: Pick<ValidateIdentity, 'identityValidationToken' | 'email'> }>()
);

export const validateLinkSuccess = createAction(
  ActionTypes.VALIDATE_LINK_SUCCESS
);

export const validateLinkFailure = createAction(
  ActionTypes.VALIDATE_LINK_FAILURE,
  props<{ payload: { code?: string; message: string; httpStatus?: number } }>()
);
